// SPDX-License-Identifier: MIT
/** Visual system: background and post-processing defaults. Scenes read colours from the brand. */
export type PostParams = {
    bloomThreshold: number;
    bloomIntensity: [
        half: number,
        quarter: number
    ];
    aberration: number;
    distortion: number;
    grain: number;
    vignette: number;
};
export type Style = {
    id: string;
    background: 'dark' | 'light';
    post: PostParams;
};
export const STYLES: Record<string, Style> = {
    'tech-noir': {
        id: 'tech-noir',
        background: 'dark',
        post: {
            bloomThreshold: 0.62,
            bloomIntensity: [0.55, 0.35],
            aberration: 0.0025,
            distortion: 0.035,
            grain: 0.035,
            vignette: 0.32,
        },
    },
    'swiss-paper': {
        id: 'swiss-paper',
        background: 'light',
        post: {
            bloomThreshold: 0.92,
            bloomIntensity: [0.15, 0.1],
            aberration: 0.0015,
            distortion: 0.01,
            grain: 0.025,
            vignette: 0.12,
        },
    },
};
export function getStyle(id: string): Style {
    const style = STYLES[id];
    if (!style)
        throw new Error(`unknown style "${id}"`);
    return style;
}
